import styled, { css } from 'styled-components';
import { em, rem } from 'styles';
import { PALETTE } from 'pages/Fields/fields.constants';

export const Rail = styled.nav`
  display: flex;
  flex-direction: column;
  gap: ${em(6)};
  min-width: 0;
`;

export const Item = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${em(10)};
    padding: ${em(10)} ${em(12)};
    background: ${theme.colors.nature.n0};
    border: none;
    border-left: ${em(2)} solid transparent;
    border-radius: ${em(theme.radius[0])};
    box-shadow: ${theme.shadows()[0]};
    text-align: left;
    cursor: pointer;

    &:hover {
      background: ${theme.colors.misc.background};
    }

    &[aria-pressed='true'] {
      background: ${theme.colors.misc.background2};
      border-left-color: ${PALETTE.brand};
    }
  `}
`;

export const Num = styled.span`
  min-width: ${em(22)};
  font-size: ${rem(14)};
  text-align: right;
  color: ${PALETTE.faint};
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(5)};
  min-width: 0;
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(8)};
`;

export const Size = styled.span`
  ${({ theme }) => css`
    font-family: ${theme.fonts.mono};
    font-size: ${rem(17)};
    font-weight: ${theme.fontWeights[1]};
    color: ${theme.colors.nature.n5};
  `}
`;

export const ClassTag = styled.span`
  padding: ${em(1)} ${em(6)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.brandDark};
  background: ${PALETTE.brandTint};
  border-radius: ${em(3)};
`;

export const MockedTag = styled.span`
  padding: ${em(1)} ${em(6)};
  font-size: ${rem(12.5)};
  color: ${PALETTE.lateText};
  background: ${PALETTE.lateTagBg};
  border-radius: ${em(3)};
`;

export const StatusLine = styled.span`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${em(4)};
    font-size: ${rem(14)};
    color: ${theme.colors.nature.n3};

    svg {
      width: ${em(14)};
      height: ${em(14)};
    }
  `}
`;

export const Pager = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: ${em(4)};
  font-size: ${rem(14)};
  color: ${PALETTE.muted};
`;

export const PagerButton = styled.button`
  padding: ${em(2)} ${em(10)};
  font-size: ${rem(16)};
  color: ${PALETTE.ink};
  background: transparent;
  border: ${em(1)} solid ${PALETTE.line};
  border-radius: ${em(14)};
  cursor: pointer;

  &:disabled {
    color: ${PALETTE.faint};
    cursor: not-allowed;
  }
`;
